import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { EntrepreneurProspectApplication } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { EntrepreneurProspectDialogDataService } from '../../entrepreneur-prospect-dialog-data.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, appService: AppService, domainData: DomainDataService, entrepreneurProspectDialogDataService: EntrepreneurProspectDialogDataService, dialogService: DialogService): GridSetup<EntrepreneurProspectApplication> {

	return {
		rowName: { singular: 'Application', plural: 'Applications' },
		getRowKey: row => '' + row.accApplicationId,
		stateKey: 'entrepreneur-prospect-dialog-applications-grid',
		actions: getActions(dialogService),
		buttons: getButtons(entrepreneurProspectDialogDataService),
		columns: getColumns(util, appService, domainData),
		// renderRowClasses: row => row.status == 'Active' ? [] : ['grid-cell-strikethrough', 'grid-cell-gray-text'],
	}
}
